import { httpService } from "@/common/services/HttpService";
import { StoreWorkstation, StoreWorkstationInput } from "@/common/models/StoreWorkstation";

class StoreWorkstationService {
  async getWorkstations(storeId: string | null): Promise<StoreWorkstation[]> {
    if (storeId === null) return Promise.resolve([]);
    const { data } = await httpService
      .getInstance()
      .get<StoreWorkstation[]>(`/api/v1/backoffice/admin/workstations/stores/${storeId}`);
    return data;
  }

  async getWorkstation(qrCode: string): Promise<StoreWorkstation> {
    const { data } = await httpService
      .getInstance()
      .get<StoreWorkstation>(`/api/v1/backoffice/admin/workstations/${qrCode}`);
    return data;
  }

  async createWorkstation(workstation: StoreWorkstationInput): Promise<StoreWorkstation> {
    const { data } = await httpService
      .getInstance()
      .post<StoreWorkstation>("/api/v1/backoffice/admin/workstations", workstation);
    return data;
  }

  async updateWorkstation(qrCode: string, workstation: StoreWorkstation): Promise<StoreWorkstation> {
    const { data } = await httpService
      .getInstance()
      .put<StoreWorkstation>(`/api/v1/backoffice/admin/workstations/${qrCode}`, workstation);
    return data;
  }
}

export const storeWorkstationService = new StoreWorkstationService();
